import 'antd/dist/antd.css';
import './App.css';

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout, Skeleton } from 'antd';
import GA from './utils/GoogleAnalytics';
import Navbar from './components/Navbar';
import { ReportFailed, ReportSuccess } from './pages/ReportResult';

const { Content, Footer } = Layout;

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const JobDetails = lazy(() => import('./pages/JobDetails'));
const Report = lazy(() => import('./pages/Report'));
const Search = lazy(() => import('./pages/Search'));

function App() {
  return (
    <Router>
      <Layout className="layout">
        <Navbar />
        <Content className="site-layout" style={{ marginTop: 64 }}>
          <div className="site" style={{ minHeight: 380 }}>
            <Suspense
              fallback={
                <div style={{ margin: 50 }}>
                  <Skeleton />
                </div>
              }>
              { GA.init() && <GA.RouteTracker /> }
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={About} />
                <Route path="/job/:id" component={JobDetails} />
                <Route exac path="/report" component={Report} />
                <Route exac path="/report-success" component={ReportSuccess} />
                <Route exac path="/report-failed" component={ReportFailed} />
                <Route path="/search" component={Search} />
              </Switch>
            </Suspense>
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          Fakejobs ©2021 Created by <a href="http://github.com/chimemoo">Chimemoo</a>
        </Footer>
      </Layout>
    </Router>
  );
}

export default App;
